import React from 'react';
import PropTypes from 'prop-types';

import { PrsButton, PrsDefaultButton } from '../../../../styles-and-themes/styles/prsButtons';
import { AlreadyLoggedInPanelContainer } from './AlreadyLoggedInPanelStyles';

const AlreadyLoggedInPanel = ({
  onBack,
  onSignOut,
}) => (
  <AlreadyLoggedInPanelContainer>
    <h2>Already Signed In</h2>
    <PrsDefaultButton
      id="back"
      onClick={onBack}
      aria-disabled="false"
    >
      Back
    </PrsDefaultButton>

    <PrsButton
      id="signOut"
      onClick={onSignOut}
      aria-disabled="false"
    >
      Sign Out
    </PrsButton>
  </AlreadyLoggedInPanelContainer>
);

AlreadyLoggedInPanel.propTypes = {
  onBack: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
};

export default AlreadyLoggedInPanel;
